import { render, staticRenderFns } from "./FormTableMpsText.vue?vue&type=template&id=5b40655b&scoped=true"
import script from "./FormTableMpsText.vue?vue&type=script&lang=js"
export * from "./FormTableMpsText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b40655b",
  null
  
)

export default component.exports